import {ActionButton} from "./ActionButton";

const SaveRecommendation = ({ saved, onClick, loading }) => {
    return (
        <ActionButton
            onClick={onClick}
            loading={loading}
            icon={saved ? "/img/icons/Huge-icon.png" : "/img/icons/saved-grey-bordered.png"}
        />
    );
};

export default SaveRecommendation;
